import { SVGProps } from "react";

export const Icon: React.FC<{type: string} & Omit<SVGProps<SVGSVGElement>, 'type'>> = ({type, className, ...props}) => <svg aria-hidden="true" className={`icon ${className}`} {...props}>
    <use xlinkHref={`#icon-${type}`}></use >
</svg>